export default "__VITE_ASSET__EuYuxR_y__"